import React from "react";

const categoryRoutes = [
  {
    path: "/categories",
    component: React.lazy(() => import("./index")),
  },
  {
    path: "/add-category",
    component: React.lazy(() => import("./AddCategory")),
  },
  {
    path: "/edit-category/:id",
    component: React.lazy(() => import("./AddCategory")),
  },
];

export default categoryRoutes;
